// These images are from the lofi.cafe project

export const OVERLAYS = [
    'https://www.lofi.cafe/gifs/static1.gif',
    'https://www.lofi.cafe/gifs/static2.gif',
    'https://www.lofi.cafe/gifs/static3.gif'
];

export const BACKGROUNDS = [
    'https://www.lofi.cafe/gifs/gfld3S4CsRXRZjqEj3.gif',
    'https://www.lofi.cafe/gifs/He1ppTVuaVSCs.gif',
    'https://www.lofi.cafe/gifs/8vRvucL4OhyjyM4A8T.gif',
    'https://www.lofi.cafe/gifs/j5zqQSABpeHCU8EpO3.gif',
    'https://www.lofi.cafe/gifs/3o6nV7ygKBVCmLPpJu.gif',
    'https://www.lofi.cafe/gifs/SJhhRPXjaTGe5MKz5N.gif'
];